module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [(_vm.data.active || _vm.rootNode) ? [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.findColspan(_vm.data)
    }
  }, [_c('orgchart-body', {
    attrs: {
      "data": _vm.data,
      "rootNode": _vm.rootNode,
      "siblingNodeCounted": _vm.siblingNodeCounted,
      "siblingNodes": _vm.siblingNodes,
      "setActiveAssistNode": _vm.setActiveAssistNode,
      "labels": _vm.labels,
      "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail
    }
  })], 1)]), _vm._v(" "), _c('orgchart-secretary', {
    attrs: {
      "data": _vm.data,
      "rootNode": _vm.rootNode,
      "filterActive": _vm.filterActive,
      "siblingNodes": _vm.siblingNodes,
      "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail
    }
  }), _vm._v(" "), (typeof _vm.data.children !== 'undefined') ? [(_vm.data.children.length > 0) ? [(_vm.filterActive(_vm.data.children).length > 0) ? _c('tr', {
    staticClass: "lines"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.findColspan(_vm.data)
    }
  }, [_c('div', {
    staticClass: "downLine"
  })])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "lines"
  }, [(_vm.filterActive(_vm.data.children).length === 1) ? [_c('td', {
    attrs: {
      "colspan": _vm.findColspan(_vm.data)
    }
  }, [_c('div', {
    staticClass: "downLine"
  })])] : (_vm.filterActive(_vm.data.children).length > 1) ? [_c('td', {
    staticClass: "rightLine"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.data.children.length - 1), function(i) {
    return [_c('td', {
      staticClass: "leftLine topLine"
    }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
      staticClass: "rightLine topLine"
    }, [_vm._v(" ")])]
  }), _vm._v(" "), _c('td', {
    staticClass: "leftLine"
  }, [_vm._v(" ")])] : _vm._e()], 2), _vm._v(" "), _c('tr', {
    staticClass: "nodes"
  }, _vm._l((_vm.data.children), function(dataChild) {
    return _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('orgchart-node', {
      attrs: {
        "data": dataChild,
        "rootNode": false,
        "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail,
        "siblingNodeCounted": _vm.data.children.length,
        "siblingNodes": _vm.data.children
      }
    })], 1)
  }))] : _vm._e()] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e213602c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orgchart/orgchartNode.vue
// module id = 3999
// module chunks = 1